import ApiToken from 'models/api_token';

export default class CreateApiToken {
  constructor(context) {
    this.context = context;
  }

  run() {
    let newToken = ApiToken.create({ name: generateUniqueName(this.context.stores.apiTokens.findAll()) });
    this.context.stores.apiTokens.setPendingNew(newToken);
    this.context.gateways.apiToken.add(this.context.stores.currentAgent.get().id, newToken.toJs());
  }
}

function generateUniqueName(apiTokens) {
  let nameSet = new Set(apiTokens.map(apiToken => apiToken.name));
  for (let i = 1; ; i++) {
    let newName = i === 1 ? BASE_NAME : `${BASE_NAME} ${i}`;
    if (!nameSet.has(newName)) {
      return newName;
    }
  }
}

const BASE_NAME = 'New Token';



// WEBPACK FOOTER //
// ./src/scripts/application/actions/api_tokens/create_api_token.js